(ns minorodata.transform-environments.subs
  (:require [re-frame.core :as re-frame]
            [minorodata.utils :as utils]
            [minorodata.app.utils :as app.utils]))


(re-frame/reg-sub
 :environments.subs/enabled?
 (fn []
   @(re-frame/subscribe [:unleash/is-enabled "fe.environments"])))

(re-frame/reg-sub
 :environments.subs/active-environment
 (fn []
   (re-frame/subscribe [:environments-panel/pull '[* {:environments-panel/environments [*]}]]))
 (fn [{:environments-panel/keys [environments active-id]}]
   (utils/find-by-field environments :environment/environment-id active-id)))

(re-frame/reg-sub
 :environments.subs/active-environment-id
 (fn []
   (re-frame/subscribe [:environments-panel/pull '[*]]))
 (fn [{:environments-panel/keys [active-id]}]
   active-id))

(re-frame/reg-sub
 :environments.subs/get-environment
 (fn [[_ env-id]]
   [(re-frame/subscribe [:environment/pull [:environment/environment-id env-id]])])
 (fn [[env]]
   env))

(re-frame/reg-sub
 :environments.subs/invalid-env?
 (fn [_ [_ env-id]]
   (boolean
    (and env-id
         (not= env-id app.utils/production-env-id)
         (not @(re-frame/subscribe [:environments.subs/get-environment env-id]))))))

(re-frame/reg-sub
 :environments.subs/production-active?
 (fn []
   [(re-frame/subscribe [:environments.subs/active-environment-id])])
 (fn [[active-id] [_ env-id]]
   (let [envs-enabled? @(re-frame/subscribe [:environments.subs/enabled?])
         env-id        (or env-id active-id)]
     (or (not envs-enabled?)
         (not env-id)
         (= env-id app.utils/production-env-id)))))

(re-frame/reg-sub
 :environments.subs/get-groups
 (fn []
   [(re-frame/subscribe [:group.subs/ordered-groups])])
 (fn [[groups]]
   groups))

(defn modified-group? [states {:group/keys [id]}]
  (->> (get states (keyword id))
       (some #(not= "unmodified" %))))

(re-frame/reg-sub
 :environments.subs/modified-groups
 (fn []
   [(re-frame/subscribe [:environments.subs/production-active?])
    (re-frame/subscribe [:environments.subs/get-groups])
    (re-frame/subscribe [:environments-panel/pull])])
 (fn [[prod-env? groups panel]]
   (let [{:environments-panel/keys [modification-states]} panel
         modified? (partial modified-group? modification-states)]
     (if-not prod-env?
       (filter modified? groups)
       []))))


(re-frame/reg-sub
 :environments.subs/all-input-tables
 (fn [db _]
   (get-in db [:input-tables/all])))


(re-frame/reg-sub
 :environments.subs/initial-input-tables
  (fn [db _]
    (get-in db [:input-tables/initial])))


(re-frame/reg-sub
 :environments.subs/tables-to-copy
  (fn [db _]
    (get-in db [:db-copy/tables])))
